import axiosSecurity from '../axios/axiosSecurity'
import { isNullOrUndefined } from '@/utils/functions'

export default class CargoService {
  static async get(ativo, departamentoId) {
    const params = new URLSearchParams()

    if (!isNullOrUndefined(ativo)) {
      params.append('Ativo', ativo)
    }

    if (departamentoId) {
      params.append('DepartamentoId', departamentoId)
    }

    return axiosSecurity.get(`cargos?${params}`).then(res => res.data.data)
  }

  static async getById(cargoId) {
    return axiosSecurity.get(`cargos/${cargoId}`).then(res => res.data.data)
  }

  static async getDepartamentosAssociadosAUmCargo(cargoId) {
    return axiosSecurity.get(`cargos/${cargoId}/departamentos`).then(res => res.data.data)
  }

  static async getDepartamentosNaoAssociados(cargoId) {
    return axiosSecurity.get(`cargos/${cargoId}/departamentos/disponiveis`).then(res => res.data.data)
  }

  static async criar(body) {
    return axiosSecurity.post('cargos', body)
  }

  static async criarAssociacaoCargoDepartamento(cargoId, body) {
    return axiosSecurity.post(`cargos/${cargoId}/departamentos`, body)
  }

  static async update(cargoId, body) {
    return axiosSecurity.put(`cargos/${cargoId}`, body)
  }

  static async ativarOuInativar(cargoId, body) {
    return axiosSecurity.put(`cargos/${cargoId}/ativado`, body)
  }

  static async ativarOuInativarAssociacaoCargoDepartamento(cargoId, departamentoId, body) {
    return axiosSecurity.put(`cargos/${cargoId}/departamentos/${departamentoId}/ativado`, body)
  }
}
